import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    BottomNavigation,
    BottomNavigationAction,
    AppBar,
    CssBaseline,
    Snackbar,
    Grid,
} from '@material-ui/core';

import HomeIcon from '@material-ui/icons/Home';
import MovieOutlinedIcon from '@material-ui/icons/MovieOutlined';
import WhatshotOutlinedIcon from '@material-ui/icons/WhatshotOutlined';
import PersonIcon from '@material-ui/icons/Person';

import AppConfig from '../../control/config';
import AppUtils from '../../control/apputlis';
import DeviceEventEmitter, { EventName } from '../../control/event';

import HomePage from '../home/Home';
import MinePage from '../mine/Mine';
import MatchPage from '../match/MatchPage';
import AnchorPage from '../anchor/AnchorPage';
import SubscribePage from '../subscribe/SubscribePage';
import MyMsg from '../setting/MyMsg';
import ChatPage from '../chat/ChatPage';
import AppData from '../../model/AppData';
import Apis from '../../network/Apis';
import GoodFriendPage from '../goodfriend/GoodFriendPage'

const HOME_TAB_ICON_0 = require("../../images/icons/shouye.png");
const HOME_TAB_ICON_1 = require("../../images/icons/shouye1.png");

const MOVIE_TAB_ICON_0 = require("../../images/icons/saicheng.png");
const MOVIE_TAB_ICON_1 = require("../../images/icons/saicheng1.png");

const VIP_TAB_ICON_0 = require("../../images/icons/dingyue.png");
const VIP_TAB_ICON_1 = require("../../images/icons/dingyue1.png");

const MINE_TAB_ICON_0 = require("../../images/icons/wode.png");
const MINE_TAB_ICON_1 = require("../../images/icons/wode1.png");

const FX_TAB_ICON_0 = require("../../images/icons/zhibo.png");
const FX_TAB_ICON_1 = require("../../images/icons/zhibo1.png");

const MS_TAB_ICON_0 = require("../../images/icons/ic_tab_live_selected.png");
const MS_TAB_ICON_1 = require("../../images/icons/ic_tab_live.png");


const navItems = [
    { text: '首页', icon: <HomeIcon />, component: <HomePage />, activeIcon: HOME_TAB_ICON_0, inactiveIcon: HOME_TAB_ICON_1 },
    { text: '赛程', icon: <MovieOutlinedIcon />, component: <MatchPage />, activeIcon: MOVIE_TAB_ICON_0, inactiveIcon: MOVIE_TAB_ICON_1 },
    { text: '消息', icon: <WhatshotOutlinedIcon />, component: <ChatPage />, activeIcon: MS_TAB_ICON_0, inactiveIcon: MS_TAB_ICON_1 },
    { text: '好友', icon: <WhatshotOutlinedIcon />, component: <GoodFriendPage />, activeIcon: VIP_TAB_ICON_0, inactiveIcon: VIP_TAB_ICON_1 },
    { text: '我的', icon: <PersonIcon />, component: <MinePage />, activeIcon: MINE_TAB_ICON_0, inactiveIcon: MINE_TAB_ICON_1 },
];


const navItems1 = [
    { text: '首页', icon: <HomeIcon />, component: <HomePage />, activeIcon: HOME_TAB_ICON_0, inactiveIcon: HOME_TAB_ICON_1 },
    { text: '赛程', icon: <MovieOutlinedIcon />, component: <MatchPage />, activeIcon: MOVIE_TAB_ICON_0, inactiveIcon: MOVIE_TAB_ICON_1 },
    { text: '主播', icon: <MovieOutlinedIcon />, component: <AnchorPage />, activeIcon: FX_TAB_ICON_0, inactiveIcon: FX_TAB_ICON_1 },
    { text: '关注', icon: <WhatshotOutlinedIcon />, component: <SubscribePage />, activeIcon: VIP_TAB_ICON_0, inactiveIcon: VIP_TAB_ICON_1 },
    { text: '我的', icon: <PersonIcon />, component: <MinePage />, activeIcon: MINE_TAB_ICON_0, inactiveIcon: MINE_TAB_ICON_1 },
];



const StyledBottomNavigationAction = withStyles((theme) => ({
    root: {
        marginTop: 3,
    },
    selected: {

    },
    label: {
        color: '#0D0D0D',
        fontSize: 9,
        marginTop: 8,
        '&$selected': {
            fontSize: 9,
            color: '#0D0D0D',
        }
    }
}))(BottomNavigationAction);


class MainPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogs: [],
            data: [],
            value: AppUtils.getStorageInt(AppUtils.MAIN_PAGE_INDEX_KEY),
            tabs: navItems,
            snackopened: false,
            message: '',
            is_has_communication: 1,
            showPoint: false,
        };

        this.setValue = this.setValue.bind(this);
        this._showDialog = this._showDialog.bind(this);
        this._removeDialog = this._removeDialog.bind(this);
        this._onMainRouter = this._onMainRouter.bind(this);
        this._onWhereRouter = this._onWhereRouter.bind(this);
    }

    setValue(newValue) {
        const { value, is_has_communication } = this.state;

        console.log('setValue', newValue);

        if (is_has_communication != 1) {
            if (newValue == 3) {
                this.setState({ message: '暂未开放', snackopened: true });
                return;
            }
        }

        if (value === newValue && newValue === 0) {
            DeviceEventEmitter.emit(EventName.HOME_REFRESH, true);
        }
        this.setState({
            value: newValue,
        });
        AppUtils.setStorageItem(AppUtils.MAIN_PAGE_INDEX_KEY, newValue);
    }

    componentDidMount() {
        DeviceEventEmitter.on(EventName.SHOW_DIALOG, this._showDialog, this);
        DeviceEventEmitter.on(EventName.REMOVE_DIALOG, this._removeDialog, this);
        DeviceEventEmitter.on(EventName.COMMENT_MAIN_ROUTER, this._onMainRouter, this);
        DeviceEventEmitter.on(EventName.COMMENT_MAIN_ROUTER_WHERE, this._onWhereRouter, this);
        DeviceEventEmitter.on(EventName.EVENT_TIM_MESSAGE_RECEIVED, this.onMessageReceived, this);

        AppUtils.YMPush('MAIN', '主界面');
        AppData.login();
        AppData.heatBeat();
        AppData.getShareConfig();
        this.getServerConfig();
    }

    componentWillUnmount() {
        DeviceEventEmitter.off(EventName.SHOW_DIALOG, this._showDialog, this);
        DeviceEventEmitter.off(EventName.REMOVE_DIALOG, this._removeDialog, this);
        DeviceEventEmitter.off(EventName.COMMENT_MAIN_ROUTER, this._onMainRouter, this);
        DeviceEventEmitter.off(EventName.COMMENT_MAIN_ROUTER_WHERE, this._onWhereRouter, this);
        DeviceEventEmitter.off(EventName.EVENT_TIM_MESSAGE_RECEIVED, this.onMessageReceived, this);

    }

    onMessageReceived = () => {
        this.setState({ showPoint: true });
    }

    getServerConfig = async () => {
        if (!AppData.ServerConfig) {
            let res = await Apis.encryptionServerConfig();
            if (res.code == 200 && res.data) {
                AppData.ServerConfig = res.data;
            }
        }
        console.log('getServerConfig', AppData.ServerConfig);
        let customTab = AppData.ServerConfig.tap_show;
        let is_has_communication = AppData.ServerConfig.is_has_communication;
        if (customTab == 1) {
            let value = this.state.value;
            if (is_has_communication != 1) {
                if (this.state.value == 3) {
                    value = 0;
                }
            }
            this.setState({ tabs: navItems1, is_has_communication: is_has_communication, value: value });
        }
    }

    _onWhereRouter(data) {
        this.setValue(data);
    }

    _onMainRouter(data) {
        this.setValue(1);
    }

    _showDialog(item) {
        console.log('_showDialog');
        const { dialogs } = this.state;
        dialogs.push(item);
        this.setState({
            dialogs: dialogs,
        });
    }

    _removeDialog(name) {
        const { dialogs } = this.state;
        for (let i = dialogs.length - 1; i >= 0; i--) {
            const item = dialogs[i];
            if (item.name === name) {
                dialogs.splice(i, 1);
            }
        }

        this.setState({
            dialogs: dialogs,
        });
    }

    render() {
        const { classes } = this.props;
        let { value, dialogs, tabs, snackopened, message, showPoint } = this.state;
        return (
            <React.Fragment>
                <CssBaseline />
                <div className={classes.paperBottom}>
                    {tabs[value].component}
                </div>
                <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
                    <BottomNavigation
                        value={Number(value)}
                        onChange={(event, newValue) => {
                            this.setValue(newValue);
                        }}
                        showLabels
                    >
                        {
                            tabs.map((n, i) => (
                                <StyledBottomNavigationAction
                                    key={i + ''}
                                    label={n.text}
                                    icon={
                                        <Grid container direction='row' justify='center' alignItems='flex-start'>
                                            <img src={i === value ? n.activeIcon : n.inactiveIcon}
                                                alt={n.text}
                                                className={classes.tabIcon}
                                            />
                                            {showPoint && i == 2 && <div className={classes.point}></div>}
                                        </Grid>
                                    }
                                />
                            ))
                        }
                    </BottomNavigation>
                </AppBar>
                {
                    dialogs.map((item, i) =>
                        (<item.dialogClass navigator={this} key={item.name + i} {...item.params} />)
                    )
                }
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackopened}
                    onClose={() => this.setState({ snackopened: false })}
                    message={message}
                    autoHideDuration={3000}>
                </Snackbar>
            </React.Fragment>
        );
    }
}

export default withStyles((theme) => ({
    appBarBottom: {
        top: 'auto',
        bottom: 0,
    },
    paperBottom: {
        paddingBottom: 50,
        backgroundColor: '#FFF',
    },
    tabIcon: {
        width: 20,
        height: 20,
    },
    point: {
        backgroundColor: '#FF0000',
        width: 6,
        height: 6,
        borderRadius: 3,
        marginLeft: 2
    }
}))(MainPage);
